import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/muZCHinuWfVhtnK6HHaXAk/PNG_2.png', 'https://cdn.magicpatterns.com/uploads/muZCHinuWfVhtnK6HHaXAk/PNG_2.png'];
export function ProductCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <section className="bg-brand-grayLight py-8 px-5 overflow-hidden" data-id="element-244">
      <div className="max-w-xl mx-auto text-center" data-id="element-245">
        <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-10 flex items-center justify-center gap-3" data-id="element-246">
          📸 MIRÁ EL MATERIAL POR DENTRO
        </h2>

        <div className="flex items-center justify-between mb-8 text-slate-400 px-2" data-id="element-247">
          <button onClick={prev} className="p-3 hover:text-brand-primary transition-colors bg-white rounded-xl shadow-sm border border-slate-100" aria-label="Anterior" data-id="element-248">
            <ChevronLeft size={24} data-id="element-249" />
          </button>

          <span className="uppercase tracking-[0.2em] text-slate-300 text-[12px] font-[600]" data-id="element-250">
            Desliza para ver más
          </span>

          <div className="flex items-center gap-6" data-id="element-251">
            <button onClick={next} className="p-3 hover:text-brand-primary transition-colors bg-white rounded-xl shadow-sm border border-slate-100" aria-label="Siguiente" data-id="element-252">
              <ChevronRight size={24} data-id="element-253" />
            </button>
          </div>
        </div>

        <div className="relative aspect-[4/3] md:aspect-[16/9] overflow-hidden mb-10 rounded-3xl bg-white shadow-xl border border-slate-100 flex items-center justify-center" data-id="element-254">
          <AnimatePresence mode="wait" data-id="element-255">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 1.05
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="w-full h-full flex items-center justify-center p-8 bg-slate-50" data-id="element-256">
              <div className="text-center" data-id="element-257">
                <h3 className="text-2xl font-black text-slate-900 mb-2" data-id="element-258">
                  Tomo {currentIndex + 1}
                </h3>
                <p className="text-slate-500 font-bold uppercase tracking-widest text-xs" data-id="element-259">
                  Vista Previa del Sistema
                </p>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-3" data-id="element-260">
          {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-10 bg-brand-primary' : 'w-2 bg-slate-200'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-261" />)}
        </div>
      </div>
    </section>;
}